import { useMutation, useQueryClient, useQuery } from '@tanstack/react-query';
import { budgetsApi } from '../api/budgets';
import { CreateBudgetRequestRequest, BudgetRequestDetailDto, BudgetRequestListItemDto, ApiError } from '../types';

export function useCreateBudgetRequest() {
  const queryClient = useQueryClient();
  return useMutation<BudgetRequestDetailDto, Error, CreateBudgetRequestRequest>({
    mutationFn: (data) => budgetsApi.create(data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['budget-requests'] });
    },
  });
}

export function useBudgetList() {
  return useQuery<BudgetRequestListItemDto[], ApiError>({
    queryKey: ['budget-requests'],
    queryFn: () => budgetsApi.list(),
  });
}

export function useBudgetById(id: string) {
  return useQuery<BudgetRequestDetailDto, ApiError>({
    queryKey: ['budget-request', id],
    queryFn: () => budgetsApi.getById(id),
  });
}

export function useApproveBudgetRequest() {
  const queryClient = useQueryClient();
  return useMutation<BudgetRequestListItemDto, Error, number>({
    mutationFn: (id) => budgetsApi.approve(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['budget-requests'] });
    },
  });
}

export function useDenyBudgetRequest() {
  const queryClient = useQueryClient();
  return useMutation<BudgetRequestListItemDto, Error, number>({
    mutationFn: (id) => budgetsApi.deny(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['budget-requests'] });
    },
  });
}

export function useEditBudgetRequest() {
  const queryClient = useQueryClient();
  return useMutation<BudgetRequestListItemDto, Error, { id: number; data: CreateBudgetRequestRequest }>({
    mutationFn: ({ id, data }) => budgetsApi.edit(id, data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['budget-requests'] });
    },
  });
}

export function useDeleteBudgetRequest() {
  const queryClient = useQueryClient();
  return useMutation<void, Error, number>({
    mutationFn: (id) => budgetsApi.delete(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['budget-requests'] });
    },
  });
}
